import React from 'react'
import { Grid, Box, Container, Typography } from '@mui/material'
import ZendeskLink from 'components/Common/ZendeskLink'
import './index.css'
import FollowedBusiness from 'components/MyBusiness/FollowedBusiness'

import SearchBar from './SearchBar'
import SearchResults from './SearchResults'
import { useSelector, useDispatch } from 'react-redux'
import { fetchMonitoredBusiness } from 'store/actions/businessListingActions'
import MainLayout from 'layouts/mainLayout'
import PoweredByEquifax from 'components/Common/PoweredByEquifax'

const sx = {
  footerWrapper: {
    display: "flex",
    padding: "0px 40px 0px 40px",
    borderTop: "1px solid #CEE4F5",
    justifyContent: "space-between",
    marginTop: "20px"
  },
  header: {
    color: "#25245f",
    marginBottom: "30px",
    fontFamily: "poppins"
  }
}

const FindPage = () => {
  const businessReducer = useSelector(state => state.businessReducer)
  const dispatch = useDispatch()
  React.useEffect(() => {
    fetchMonitoredBusiness(dispatch)
  }, [dispatch])

  return (
    <MainLayout>
      <Container sx={{ marginTop: "25px" }}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography variant="h4" sx={sx.header}>
              Find a Business
            </Typography>
            <SearchBar />
            {businessReducer.searchList || businessReducer.showSpinner ? (
              <SearchResults />
            ) : (
              <FollowedBusiness />
            )}
          </Grid>
        </Grid>
      </Container>
      <Box sx={sx.footerWrapper}>
        <PoweredByEquifax searchList={businessReducer.searchList} showSpinner={businessReducer.showSpinner} />
        <ZendeskLink />
      </Box>
    </MainLayout>
  )
}

export default FindPage
